"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActionFeedbacks;
(function (ActionFeedbacks) {
    ActionFeedbacks["JOINED_GROUP_HUB"] = "joinedGroupHub";
    ActionFeedbacks["GROUP_HUB_INVITE_NOT_FOUND"] = "groupHubInviteNotFound";
    ActionFeedbacks["GROUP_HUB_NOT_FOUND"] = "groupHubNotFound";
    ActionFeedbacks["EXISTING_GROUP_HUB_MEMBER"] = "existingGroupHubMember";
    ActionFeedbacks["ACCOUNT_LOCKED"] = "accountLocked";
    ActionFeedbacks["EDITED_GROUPHUB"] = "editedGroupHub";
    ActionFeedbacks["LEFT_GROUPHUB"] = "leftGroupHub";
    ActionFeedbacks["DELETED_GROUPHUB"] = "deletedGroupHub";
    ActionFeedbacks["GROUPHUB_CREATED"] = "groupHubCreated";
    ActionFeedbacks["ACCOUNT_CLOSED"] = "accountClosed";
    ActionFeedbacks["ACCOUNT_CLOSED_FOR_USER"] = "accountClosedForUser";
    ActionFeedbacks["RESET_TOKEN_EXPIRED"] = "resetTokenExpired";
    ActionFeedbacks["INVALID_URL"] = "invalidUrl";
    ActionFeedbacks["INVITE_TOKEN_INVALID"] = "inviteTokenInvalid";
    ActionFeedbacks["INVITE_TOKEN_ERROR"] = "inviteTokenError";
    ActionFeedbacks["PAGE_NOT_FOUND"] = "pageNotFound";
    ActionFeedbacks["OCCASION_NOT_FOUND"] = "eventNotFound";
    ActionFeedbacks["OCCASION_ATTENDING"] = "eventAttending";
    ActionFeedbacks["OCCASION_INTERESTED"] = "eventInterested";
    ActionFeedbacks["REDIRECT_TO_RELATED_PAGE"] = "redirectToRelatedPage";
    ActionFeedbacks["REDIRECT_TO_RELATED_PAGE_FOR_BASE_USERS"] = "redirectToRelatedPageForBaseUsers";
})(ActionFeedbacks || (ActionFeedbacks = {}));
exports.default = ActionFeedbacks;
//# sourceMappingURL=ActionFeedbackTypes.js.map